export const customPriceLevelId = '-1';
export const listPriceLevelId = '1';
